import { Button, Checkbox, FormControl, FormErrorMessage, FormLabel, Input, Stack } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import yup from "../../yup";
import { PasswordInput } from "./PasswordInput";
import authApi from "../../api/authApi";
import useAuth from "../../hooks/useAuth";
import { useMutation } from "@tanstack/react-query";

interface Inputs {
  email: string;
  password: string;
}

const schema: yup.SchemaOf<Inputs> = yup.object({
  email: yup.string().email().required().label("البريد الإلكتروني"),
  password: yup.string().required().min(6).label("كلمة المرور"),
});

export default function LoginForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({ resolver: yupResolver(schema) });

  const { onAuth } = useAuth();

  const { mutate, isLoading } = useMutation(authApi.login, {
    onSuccess: ({ token }) => onAuth(token),
  });

  return (
    <form onSubmit={handleSubmit((data) => mutate(data))} noValidate>
      <Stack spacing="6">
        <Stack spacing="5">
          <FormControl isInvalid={!!errors.email}>
            <FormLabel>البريد الإلكتروني</FormLabel>
            <Input type="email" {...register("email")} />
            <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={!!errors.password}>
            <FormLabel>كلمة المرور</FormLabel>
            <PasswordInput {...register("password")} />
            <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
          </FormControl>
        </Stack>
        <Checkbox defaultChecked>تذكرني</Checkbox>
        <Button colorScheme="teal" type="submit" isLoading={isLoading}>
          تسجل الدخول
        </Button>
      </Stack>
    </form>
  );
}
